<template>
  <a-modal
    :visible="visible"
    @cancel="
      () => {
        visible = false
      }
    "
    :getContainer="() => document.getElementById('app')"
    :footer="null"
    width="740px"
    title="取色器"
  >
    <div
      class="content"
      :style="{ height: '700px', width: '700px', background: `url(${src})`, margin: '0 auto', position: 'relative' }"
      @mouseover="showMagnifier = true"
      @mouseout="showMagnifier = false"
      @mousemove="mousemove"
      @click="$emit('change', color)"
    >
      <div class="magnifier" v-if="showMagnifier" ref="magnifier" :style="{ backgroundImage: `url(${src})` }">
        <div class="center"></div>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'ColorPickModal',
  data() {
    return {
      visible: false,
      src: '',
      showMagnifier: false,
      ctx: null,
      color: ''
    }
  },
  methods: {
    mousemove(e) {
      const magnifier = this.$refs.magnifier
      magnifier.style.left = e.offsetX - 50 + 'px'
      magnifier.style.top = e.offsetY - 50 + 'px'
      magnifier.style.backgroundPositionX = -3 * e.offsetX + 50 + 'px'
      magnifier.style.backgroundPositionY = -3 * e.offsetY + 50 + 'px'
      const imageData = this.ctx.getImageData(e.offsetX, e.offsetY, 1, 1)
      this.color = this.getHexColor(`rgba(${imageData.data.join(',')})`)
    },

    getHexColor(color) {
      var values = color
        .replace(/rgba?\(/, '')
        .replace(/\)/, '')
        .replace(/[\s+]/g, '')
        .split(',')
      const a = parseFloat(values[3] || 1)
      const r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255)
      const g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255)
      const b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255)
      return (
        '#' + ('0' + r.toString(16)).slice(-2) + ('0' + g.toString(16)).slice(-2) + ('0' + b.toString(16)).slice(-2)
      )
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  &:hover {
    cursor: none;
  }
  .magnifier {
    height: 100px;
    width: 100px;
    background-size: 2100px;
    pointer-events: none;
    border-radius: 50%;
    position: absolute;
    // border: 1px solid #cccccc;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    .center {
      height: 3px;
      width: 3px;
      border-radius: 50%;

      background: white;
    }
  }
}
</style>
